import { cn } from "@/lib/utils";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";

export interface ULThemeLogoProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Alt Text for the logo image
   */
  altText: string;
  /**
   * Optional Classes for custom overrides applied to the wrapping container
   */
  className?: string;
}

const ULThemeLogo = ({ altText, className, ...rest }: ULThemeLogoProps) => {
  const logoSrc = extractTokenValue("--ul-theme-widget-logo-url");
  console.log(logoSrc);
  const isLogoHidden =
    extractTokenValue("--ul-theme-widget-logo-position") === "none";

  if (isLogoHidden || !logoSrc) return null;

  return (
    <div className={cn("flex flex-wrap justify-widget-logo", className)}>
      <img
        src={logoSrc}
        alt={altText}
        className="h-(--height-widget-logo) w-auto max-w-full"
        loading="eager"
        decoding="async"
        fetchPriority="high"
        {...rest}
      />
    </div>
  );
};
export default ULThemeLogo;
